// The site has no backend: the contact form hands a prefilled message to
// the visitor's mail client. See docs/decisions/001-public-marketing-site.md.
export function buildContactMailto({ to, values, serviceLabel }) {
    const subject = `Solicitud de asesoría — ${values.name}${values.company ? ` (${values.company})` : ''}`;
    const lines = [
        `Nombre: ${values.name}`,
        `Correo: ${values.email}`,
        values.phone ? `Teléfono: ${values.phone}` : null,
        values.company ? `Medio o empresa: ${values.company}` : null,
        `Servicio de interés: ${serviceLabel}`,
        '',
        values.message,
        '',
        'Acepto la política de tratamiento de datos personales de Total Medios.',
    ].filter(line => line !== null);

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
}
